export const debounce = (fn: Function, ms: number) => {
    let timeout: ReturnType<typeof setTimeout> | undefined
    return (...args: any[]) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
            fn(...args)
        }, ms)
    }
}